// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"297":"5100e4cf","819":"6f1812e9"}[chunkId] + ".chunk.js";
};